import React, { Component } from 'react';
import ProjectsLayout from '../../templates/project';
import ProfilesEditForm from './../../elements/project/profiles';
import Loading from "../../elements/loading";

class Profiles extends Component {
	render(){
		let { project } = this.props;
		return (
			project.profiles.isFetching ?
				<Loading message="Cargando Datos adicionales..." /> :
				<ProfilesEditForm
					profiles={project.profiles}
					permissions={project.permissions}
					match={this.props.match}
					loadFormData={this.props.loadFormData}
					history={this.props.history}
					setSystemNotification={this.props.setSystemNotification}
					projectEmployeeSave={this.props.projectEmployeeSave}/>
		)
	}

	componentWillMount() {
		let { modality, state, municipality } = this.props.match.params;
		this.props.projectEmployees(modality, state, municipality);
	}

	componentWillReceiveProps(newprops) {
		let { modality, state, municipality } = newprops.match.params;
		if(newprops.location.pathname !== this.props.location.pathname) {
			this.props.projectEmployees(modality, state, municipality);
		}
	}
}

export default ProjectsLayout(Profiles, {subnav: 5});



// WEBPACK FOOTER //
// ./src/layouts/project/profiles.jsx